import React from "react";

interface IStyleProps {
  fillColor?: string;
}

const EditButtonTextIcon: React.FC<IStyleProps> = (props) => {
  return (
    <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="21" height="15" rx="2" fill="black"/>
    <path d="M6 2V5.25649H8.00058V4.11172H10.0012V10.4469H8.76922V12.5586H13.2337V10.4469H12.0017V4.11172H14.0023V5.25649H16.0029V2H6Z" fill="#EAEBF0"/>
    </svg>
  );
}

export default EditButtonTextIcon;